<template>
  <DialogTemplateToolkit
    data-qa="reject-dialog"
    :dialog="dialog"
    first_btn="Application.Reject"
    :title="`${$t('Application.WhyDecline')} ${ name ? ' ' + name : '' }?`"
    @apply="apply"
    @close="close">
    <template v-slot:activator-btn>
      <sButton
        v-if="!mode !== 'list'"
        :class="className"
        :color="mode==='button' ? 'var(--black-color)' : 'var(--white-color)'"
        data-qa="btn-reject-dialog"
        :disabled="disabled"
        icon="cross"
        icon-size="12px"
        :loading="!!loading"
        style="max-height: 40px;"
        type="text"
        @click="dialog = true">
        {{ label ? label : $t('Application.Reject') }}
      </sButton>
      <v-list-item
        v-else
        class="h11-links mx-0 px-1"
        data-qa="item-reject-dialog"
        text
        @click="dialog = true">
        <sIcon
          class="pr-1"
          size="18"
          type="cross"/> {{ label ? label : $t('Application.Reject') }}
      </v-list-item>
    </template>
    <template v-slot:card-text>
      <SpilkaFormioMFOld
        v-if="dialog && formParams && formParams.formCode"
        ref="formioForm"
        :disabled="!!loading"
        :form-params="formParams"
        :hide-submit="true"
        :key-draft="keyDraft"
        :show-alert="false"
        @formLoad="showTour"
        @initialized="loadForm = false"
        @submit-error="errorFormio"
        @submit-valid="agreeFormio"/>
      <v-row
        v-else
        no-gutters>
        <v-col :class=" offer ? '' : 'col-9 py-0' ">
          <v-card-actions class="px-0 pt-7 ">
            <sForm
              ref="rejectDialogForm"
              :disabled="!!loading"
              label-position="top"
              label-width="0px"
              :model="{text}"
              :rules="rules">
              <sFormItem
                prop="text">
                <sInput
                  data-qa="reject-dialog-textarea"
                  :max-length="tender ? 1500 : 4000"
                  max-rows="15"
                  rows="5"
                  show-word-limit
                  type="textarea"
                  :value.sync="text"/>
              </sFormItem>
            </sForm>
            <v-col
              v-if="offer"
              class="justify-end d-flex pa-3 col-3 align-self-end ml-4 info-block secondary__green_chosen ">
              <span
                class="h7-text"
                data-qa="reject-dialog-textarea-hint"> {{ $t('Tenders.AfterRejectedOffer') }} </span>
            </v-col>
          </v-card-actions>
        </v-col>
      </v-row>
    </template>
    <template
      v-if="formParams"
      #first_btn>
      <sButton
        data-qa="btn-send"
        :loading="loadForm || !!loading"
        @click="submitFormio">
        {{ $t('Application.Reject') }}
      </sButton>
    </template>
    <template
      v-if="keyDraft"
      #in-footer>
      <sButton
        class="my-auto"
        data-qa="save-as-draft"
        icon="diskette"
        :loading="loadForm || !!loading"
        type="text"
        @click="saveDraft">
        {{ $t('Application.SaveAsDraft') }}
      </sButton>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import SpilkaFormioMFOld from 'components/common/SpilkaFormioMFOld.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { storageMixin, modalMixin, snackbarMixin, validateRuls } from 'mixins'
import { eventBus } from '@/main'

export default {
  name: 'rejectDialog',
  mixins: [ storageMixin, snackbarMixin, modalMixin, validateRuls ],
  data() {
    const that = this
    return {
      dialog: false,
      text: '',
      loadForm: true,
      rules: {
        text: [
          {
            type: 'string',
            trigger: 'change',
            max: that.tender ? 1500 : 4000,
            message: that.$t('Validate.maxLength', {number: that.tender ? 1500 : 4000, type: that.$tc('Common.characters', 10) })
          }
        ],
      }
    }
  },
  mounted() {
    this.rules.text.push(this.commentValidateRule[0])
  },
  props: {
    elements: Array,
    application: Object,
    disabled: Boolean,
    className: String,
    mode: {
      type: String,
      default: 'button',
      validator: function (value) {
        const correct = ['button', 'list', 'toolbar'].indexOf(value) !== -1
        return correct
      },
    },
    tender: Object,
    loading: Boolean,
    offer: Boolean,
    formParams: {
      type: Object,
    },
    /**
     * Название кнопки
     */
    label: {
      type: String
    }
  },
  computed: {
    keyDraft() {
      let result
      if (this.formParams?.formCode && this.formParams?.params?.length) {
        const tenderId = this.formParams.params.find(i => i.key === 'tenderId')?.value
        if (tenderId) { result = `rejectDialog-${tenderId}-${this.formParams.formCode}-v-${this.formParams.version}_draft` }
      }
      return result
    },
    showBtn() {
      let result = true
      if (this.formParams && !this.formParams.formCode) {
        result = false
      }
      return result
    },
    items: {
      get() {
        return this.elements
      },
      set(value) {
        this.$emit('update:elements', value )
      }
    },
    app: {
      get() {
        return this.application
      },
      set(value) {
        this.$emit('update:application', value )
      }
    },
    name() {
      let result = ''
      if (this.items?.length == 1 && !this.tender) {
        result = this.items[0].resource?.fullName || this.items[0].resourceName
      } else if (this.tender) {
        result = this.$t('Tenders.TenderApproval')
      } else if (this.offer) {
        result = this.$t('Tenders.CheckedOffers')
      }
      return result
    }
  },
  methods: {
    async showTour() {
      this.$nextTick(async () => {
        await this.$_getPropFromDBStorage('rejectDialog_tour', false)
          .then(async (viewedTour) => {
            if (viewedTour || !this.keyDraft) { return }
            eventBus.$emit('startTour', 'confirmReject')
            await this.$_savePropToDBStorage('rejectDialog_tour', true, new Date().setDate(new Date().getDate() + 180))
          })
      })
    },
    saveDraft() {
      this.$refs.formioForm.saveDraft()
      this.$notice.info({
        title: this.$t('Application.DraftSaved'),
        duration: 10
      })
    },
    submitFormio() {
      this.$emit('update:loading', true)
      this.$refs.formioForm.submit()
    },
    errorFormio() {
      this.$emit('update:loading', false)
    },
    async agreeFormio(params) {
      await this.$emit('callback', null, false, params)
      this.close()
    },
    async apply() {
      this.$emit('update:loading', true)
      await this.$refs.rejectDialogForm.validate()

      this.close()
      this.items?.forEach( el => el.isActive = false)
      this.$emit('callback', this.text, false)
      this.text = ''
      if (this.keyDraft) {
        await this.$_deletePropFromDBStorage(this.keyDraft)
        //await this.$_deletePropFromDBStorage(localKey.replace('rejectDialog-', 'confirmTenderAgreement-'))
      }
    },
    close() {
      this.dialog = false
    }
  },
  components: {
    SpilkaFormioMFOld,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.info-block {
  width: 232px;
  border-radius: 8px;
  height: min-content;
  margin: 0 auto auto;
}
</style>
